import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import MainImg from '../img/art director.webp';
// import BgImg from '../img/background.jpg';

// Updated container without scale
const container = {
  hidden: { opacity: 0 }, // Set initial opacity to 0 for hidden state
  visible: { opacity: 1 }  // Set final opacity to 1 for visible state
};

// Individual variants with smooth transitions
const headingVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { delay: 1, duration: 0.8, ease: "easeInOut" }
  }
};

const paragraphVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { delay: 1.5, duration: 0.8, ease: "easeInOut" }
  }
};

const buttonVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { delay: 2, duration: 0.8, ease: "easeInOut" }
  }
};

const imageVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { delay: 2.5, duration: 0.8, ease: "easeInOut" }
  }
};

const MainSection = () => {
  const ref = useRef(null); // Create a ref for the component
  const isInView = useInView(ref, { once: true }); // Check if the component is in view
  const navigate = useNavigate();
  return (
    <motion.div
      ref={ref}
      className='main-container'
      variants={container}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"} // Trigger animation based on visibility
    >
      <motion.div className='main-list column1'>
        <motion.h2 className='heading' variants={headingVariant}>
          Mazhar khan
        </motion.h2>
        <motion.p className='para' variants={paragraphVariant}>
          In the realm of television, Mazhar has served as both an art director and assistant art director for numerous notable productions.
        </motion.p>
        <motion.button
          onClick={() => navigate('/about')} // Use navigate here
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          variants={buttonVariant}
          style={{ cursor: 'pointer' }} // Ensures it's visually clickable
        >
          Learn more
        </motion.button>


      </motion.div>
      <motion.div className='main-list column2'>
        <motion.img
          src={MainImg}
          alt="Main"
          className='main-img'
          variants={imageVariant}
        />
        {/* <motion.img
          src={BgImg}
          alt='bg-img'
          className='main-bg-img'
          variants={imageVariant}
        /> */}
      </motion.div>
    </motion.div>
  );
};

export default MainSection;
